import styled from 'styled-components';
import theme from 'src/theme';
import { IconButton } from 'src/styles/button.style';

export interface IWrapperProps {
    environment: string;
}

export interface IMenuButtonProps {
    isWide?: boolean;
    isExtraWide?: boolean;
    isDisabled?: boolean;
}

export const Wrapper = styled.div<IWrapperProps>`
    color: ${(props) => props.theme.legacyColors.primaryTextColor};
    grid-area: header-panel;
    background-color: ${(props) =>
        props.environment === 'localhost' || props.environment === 'dev'
            ? theme.colors.background.lightYellow
            : props.environment === 'qa'
            ? theme.colors.background.orange
            : theme.colors.background.white};
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 6px 2px #ddd;
    margin: 0 0 ${(props) => props.theme.constants.pageHeaderMargin};
    height: ${(props) => props.theme.constants.pageHeaderHeight};
    padding-right: 0.25rem;

    @media print {
        display: none;
    }

    h1 {
        font-size: 1.5rem;
        font-weight: 200;
        margin: 0 0 0 20px;
        position: relative;

        .sub-header {
            position: absolute;
            top: -1px;
            right: -31px;
            font-size: 1rem;
        }
    }
`;

export const Title = styled.h1`
    text-transform: capitalize;
    padding: 10px 2rem 10px 0;
    text-align: center;
    border: 1px ${theme.colors.border.panel};
    margin: 0 10px 0 0;
    font-size: 1.75rem;
    border-right-style: solid;
    font-weight: 100;
`;

export const LeftRotationInfoWrapper = styled.div`
    display: flex;
    flex: 0 0 100%;
    max-width: 100%;
    align-items: center;
    padding: 0 0 0 15px;
    justify-content: flex-start;
`;

export const RightRotationInfoWrapper = styled.div`
    display: flex;
    flex: 0 0 20%;
    justify-content: flex-end;
    align-items: right;
`;

export const LeftContentWrapper = styled.div`
    flex: 0 0 75%;
    max-width: 75%;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &.verification-header {
    }

    &.stowage-header {
        flex: 0 0 auto;
    }
`;

export const RightContentWrapper = styled.div`
    font-size: 0.7rem;
    font-weight: 400;
    display: flex;
    flex: 1 1 22%;
    max-width: 22%;
    justify-content: flex-end;
    align-items: center;

    label {
        margin: 0 2px 0 20px;
        font-weight: 500;
    }

    table {
        float: right;
        margin: 5px 10px;

        td {
            padding: 0 15px;
            margin: 0;
            line-height: 20px;
            text-align: center;
            border: 1px ${theme.colors.border.rightStyle};
            border-right-style: solid;
            border-left-style: solid;
        }
    }

    .heading td {
        font-weight: 500;
    }

    .app-menu {
        button {
            border: none;
            cursor: pointer;
            outline: 0;
            vertical-align: middle;
            border-radius: 0;
            font-size: 0.7rem;
            text-align: center;
            margin: 0 5px 0 0;
            background: none;
            padding: 0.15em 0.5em;

            i {
                display: block;
                cursor: pointer;
                outline: 0;
                padding: 0;
                text-align: center;
            }

            .icon-label {
                font-size: 0.7rem;
                display: block;
            }
        }
    }
`;

export const VersionWrapper = styled.div`
    font-weight: 400;
    font-size: 0.7em;
    position: absolute;
    top: 29px;
    left: 84px;
`;

export const IconWrapper = styled.div`
    border-left: 1px solid ${theme.colors.border.panel};
    display: flex;
    height: 40px;
    padding: 0 5px;
    grid-gap: 2px;
    &.no-border {
        border-left: 0;
    }
`;

export const HeaderItemWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const Logo = styled.img`
    position: absolute;
    top: 10px;
    left: 10px;
    width: 30px;
    fill: ${theme.legacyColors.primaryTextColor};
`;

export const LogoWrapper = styled.div`
    display: flex;
    align-items: baseline;

    img {
        margin-right: 2rem;
    }
`;

export const AppsMenu = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 5px;
    position: relative;
    svg {
        fill: ${theme.legacyColors.primaryTextColor};
        width: 16px;
    }
    button {
        border: 0;
        padding: 0;
        font-size: 0.8rem;
        i,
        label {
            display: block;
            text-align: center;
            margin: 0 0 5px;
            font-size: 0.75rem;
        }
    }
`;

export const VerificationSelectWrapper = styled.div`
        display: flex;
        justify-content: flex-start;
        margin-left: 5rem;
        grid-gap: 1rem;
        width: 100%;
    }   
`;

export const VerificationLeftWrapper = styled.div`
        justify-self: flex-start;
        width: 100%;
        flex: 0 0 70%;
        display: flex;
        grid-gap: 1rem;
    }   
`;

export const VerificationRightWrapper = styled.div`
        justify-self: flex-end;
        flex: 0 0 auto;
    }   
`;

export const StowageWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const MasterButtonMenu = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    margin-left: 0px;
    padding: 0 0 0 10px;
    position: relative;
    width: 100px;

    .menu-item {
        font-size: 0.8rem;
        font-weight: 500;
        background: ${theme.colors.pageHeader.masterButton.background};
        padding: 1px 8px;
        border-radius: 4px;
        cursor: pointer;
        position: relative;
        &.selected,
        &.selected .icon-button {
            background: ${theme.colors.pageHeader.masterButton.selected};
            color: ${theme.colors.pageHeader.masterButton.text};
        }
    }

    .separator {
        border-right: 1px solid ${theme.colors.pageHeader.masterButton.text};
        height: 30px;
        display: block;
        margin: 0px 10px;
    }

    .icon-button {
        padding: 0 4px;
        font-size: inherit;
    }
`;

export const ExtraButtonMenu = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 4px;
    background: ${theme.colors.background.white};

    .menu-item {
        font-size: 0.8rem;
        font-weight: 500;
        background: ${theme.colors.pageHeader.extraButton.background};
        padding: 1px 8px;
        border-radius: 4px;
        cursor: pointer;
        background: #eee;
        &.selected {
            background: ${theme.colors.pageHeader.extraButton.selected};
            color: ${theme.colors.pageHeader.extraButton.selectedText};
        }
    }
`;

export const MenuItemButton = styled(IconButton)<IMenuButtonProps>`
    position: relative;
    font-size: 0.75rem;
    border: 1px solid ${theme.colors.border.panel};
    width: 30px;
    height: 25px;
    &:hover {
        background: ${theme.colors.background.hover.default};
    }
    .menu-item {
        position: relative;
        padding: 4px 8px;
    }
    .red-icon {
        top: -10px;
    }
    .icon-text {
        font-weight: 600;
        margin: 0 2px;
    }
    ${(props) => {
        let wideStyle = '';
        if (props.isWide || props.isExtraWide) {
            wideStyle = `
            gap: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            @media only screen and (max-width: 1440px) {
                max-width: 85px;
            }
            `;
        }

        if (props.isWide) {
            wideStyle = `
            width: 80px;
            ${wideStyle}`;
        }

        if (props.isExtraWide) {
            wideStyle = `
            width: 100px;
            ${wideStyle}`;
        }

        return wideStyle;
    }};
    ${(props) => {
        let disabledStyle = '';
        if (props.isDisabled) {
            disabledStyle = `
            cursor: not-allowed;
            .icon, .icon-text{
                opacity: 0.8;
            } 
                          
            `;
        }

        return disabledStyle;
    }};
`;

export const ListItemIcon = styled.span<IMenuButtonProps>`
    position: relative;
    font-size: 0.75rem;
    width: 30px;
    height: 25px;
`;

export const Separator = styled.span`
    border-left: 1px solid #ccc;
    width: 1px;
`;

// export const ShareStowagePlanPanel = styled.ul`
//     position: absolute;
//     background: ${theme.colors.background.white};
//     padding: 10px;
//     top: 35px;
//     left: 0;
//     z-index: 11;
//     width: 300px;
//     box-shadow: ${theme.colors.shadow.panel} 0px 2px 6px 2px;

//     .dd-heading {
//         margin: 0 0 5px 0;
//         font-size: 0.7rem;
//         color: ${theme.colors.pageHeader.shareStowagePanel.heading};
//     }

//     .dd-item {
//         margin: 5px 0 5px 0;
//         font-size: 0.8rem;
//     }

//     .separator {
//         margin: -15px 0 35px 0px;
//         border-bottom: 1px solid ${theme.colors.border.ccc};
//     }

//     button {
//         margin: 10px 0px 10px 0;
//         padding: 5px 10px;
//         font-size: 0.75rem;
//         border: 1px solid ${theme.colors.pageHeader.shareStowagePanel.button.border};
//         color: ${theme.colors.pageHeader.shareStowagePanel.button.text};
//         cursor: pointer;
//         position: relative;
//         width: 150px;
//     }
//     textarea {
//         width: 100%;
//         height: 65px;
//         border-radius: 4px;
//         border: 1px solid ${theme.colors.border.input};
//         color: ${theme.colors.pageHeader.shareStowagePanel.text};
//         font-size: 0.7rem;
//         padding: 5px;
//     }
// `;
